export function timeAgo(date) {
    if (typeof date !== 'undefined') {
        const dateAgo = (new Date().valueOf() / 1000 - date) / (60 * 60 * 24)
        let resStr = ''
        if (dateAgo > 30 && dateAgo <= 365) {
            resStr = Math.floor(parseInt(dateAgo / 30)).toString() + (Math.floor(parseInt(dateAgo / 30)) === 1 ? ' month' : ' months') + ' ago'
        } else if (dateAgo > 365) {
            resStr = Math.floor(parseInt(dateAgo / 365)).toString() + (Math.floor(parseInt(dateAgo / 365)) === 1 ? ' year' : ' years') + ' ago'
        } else if (dateAgo > 0 && dateAgo < 1) {
            if ((new Date().valueOf() / 1000 - date) < 3600) {
                resStr = Math.floor((new Date().valueOf() / 1000 - date) / 60).toString()
                resStr += (Math.floor((new Date().valueOf() / 1000 - date) / 60)) === 1 ? ' minute' : ' minutes' + ' ago'
            } else {
                resStr = (Math.floor((new Date().valueOf() / 1000 - date) / 3600)).toString() + ((Math.floor((new Date().valueOf() / 1000 - date) / 3600)) === 1 ? ' hour' : ' hours') + ' ago'
            }
        } else {
            resStr = Math.floor(dateAgo).toString() + (Math.floor(parseInt(dateAgo)) === 1 ? ' day' : ' days') + ' ago'
        }
        return resStr
    } else {
        return 'Just Now'
    }
}